module.exports = __webpack_public_path__ + "img/adorama.586c7ec5.png";